/**
 * Hand-written additions not covered by the orval-generated client.
 */
import { useMutation, type UseMutationOptions, type UseMutationResult, type MutationFunction } from "@tanstack/react-query";
import { customFetch, type ErrorType } from "./custom-fetch";

// ── View count ────────────────────────────────────────────────────────────────

export interface ViewResult {
  contentId: number;
  viewCount: number;
  gloRewarded?: number;
}

export const recordMembersContentView = async (
  id: number,
  options?: RequestInit,
): Promise<ViewResult> =>
  customFetch<ViewResult>(`/api/members/content/${id}/view`, {
    ...options,
    method: "POST",
  });

export const useRecordMembersContentView = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof recordMembersContentView>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof recordMembersContentView>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["recordMembersContentView"];
  const { mutation: mutationOptions } = options
    ? options.mutation && "mutationKey" in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof recordMembersContentView>>,
    { id: number }
  > = ({ id }) => recordMembersContentView(id);

  return useMutation({ mutationFn, ...mutationOptions });
};
